import _ from 'lodash';

const requireModule = require.context('.', false, /\.js$/);
const modules = {};

requireModule.keys().forEach(filename => {
  if (filename === './index.js') {
    return;
  }

  const moduleName = _.camelCase(
    filename.replace(/(\.\/|\.js)/g, '')
  );

  modules[moduleName] = requireModule(filename).default || requireModule(filename);
});

export default modules;
